import { render, staticRenderFns } from "./walkin-visits-settings.vue?vue&type=template&id=35e11900&scoped=true"
import script from "./walkin-visits-settings.vue?vue&type=script&lang=js"
export * from "./walkin-visits-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e11900",
  null
  
)

export default component.exports